/* eslint prefer-destructuring: 0 */
export const ENV = process.env.ENV;
export const TAG = process.env.TAG;
export const DD_CLIENT_KEY = process.env.DD_CLIENT_KEY;
